module.exports = __webpack_public_path__ + "static/media/avatar46.a550b6e3.png";